import { useState } from 'react';

interface ModalButtonProps {
  modal: (open: boolean, closeModal: () => void) => React.ReactNode;
  button: (openModal: () => void) => React.ReactNode;
}

export function ModalButton(props: ModalButtonProps) {
  const { modal, button } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      {button(() => setOpen(true))}
      {modal(open, () => setOpen(false))}
    </>
  );
}
